import { SESSION_EXPIRED } from "@/constants/settings";

import { ApiError } from "@/types";

export const handleApiResponse = async (response: Response) => {
  if (response.status === 401) {
    throw SESSION_EXPIRED;
  }

  if (!response.ok) {
    let errorData: { error?: string };
    try {
      errorData = await response.json();
    } catch {
      if (response.status === 429) {
        errorData = { error: "Too many requests. Please wait a moment and try again." };
      } else {
        errorData = { error: `Request failed with status ${response.status}` };
      }
    }
    if (response.status === 429 && !errorData.error?.includes("Too many requests")) {
      errorData.error = "Too many requests. Please wait a moment and try again.";
    }
    const error = errorData as ApiError;
    (error as ApiError & { status?: number }).status = response.status;
    throw error;
  }

  const responseJson = await response.json();

  if (responseJson.error) {
    const error = responseJson as ApiError;
    (error as ApiError & { status?: number }).status = response.status;
    throw error;
  }

  return responseJson;
};
